import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useContext, useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import {  getAllByOrganizationId, getDeparment } from "../../service/User";
import AppContext from "../../context/AppContext";
import translations from "../common/Translations";
const CreateDepartment = ({ setOpen, open , organizationID, setgetDeparment}) => {

    const { theme, langMode } = useContext(AppContext);
    const [deparmentName, setDeparmentName] = useState("")

    const handleAddDeparment = async () => {
        const data = await getDeparment({ organizationId: organizationID, name: deparmentName })
        const resule = await getAllByOrganizationId(organizationID)
        setgetDeparment(resule)
        setOpen(false)
    }

    useEffect(() => {
        setDeparmentName('')
    }, [open])

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog
                as="div"
                className="relative z-10"
                onClose={setOpen}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div
                        className={`fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity`}
                    />
                </Transition.Child>
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel
                                className={`relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg ${theme === "dark"
                                    ? "dark-mode"
                                    : theme === "high-contrast"
                                        ? "high-contrast"
                                        : ""
                                    }`}
                            >
                                <div
                                    className={`bg-white rounded-lg shadow ${theme === "dark"
                                        ? "dark-mode"
                                        : theme === "high-contrast"
                                            ? "high-contrast"
                                            : ""
                                        }`}
                                >
                                    <div className="flex items-center justify-between p-2 md:p-5 rounded-t dark:border-gray-600">
                                        <h3 className="text-base font-bold text-[#000000] dark:text-white">
                                          {translations[langMode].addDepartment}
                                        </h3>
                                        <button
                                            type="button"
                                            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-[20px] h-[20px] ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                            data-modal-hide="small-modal"
                                            onClick={() => setOpen(false)}
                                        >
                                            <RxCross2 />
                                            <span className="sr-only">Close modal</span>
                                        </button>
                                    </div>
                                    <div className="p-4 grid grid-cols-1 gap-x-8 xsm:gap-y-10 gap-y-6 sm:grid-cols-4">

                                        <div className="col-span-12">
                                            <div className="relative flex xsm:flex-row flex-col gap-y-2 xsm:justify-between justify-start xsm:items-center items-start">
                                                <label
                                                    className={`block text-[14px] font-medium text-[#000000] ${theme === "dark"
                                                        ? "dark-mode "
                                                        : theme === "high-contrast"
                                                            ? "high-contrast  "
                                                            : ""
                                                        }`}
                                                >
                                                    Department Name
                                                </label>
                                                <input
                                                    type="text"
                                                    value={deparmentName}
                                                    onChange={(e) => setDeparmentName(e.target.value)}
                                                    placeholder={translations[langMode].entername}
                                                    className={`mt-1 block max-w-[220px] w-full rounded-md border border-[#777777] shadow-sm
                                     focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50 sm:text-sm ${theme === "dark"
                                                            ? "dark-mode "
                                                            : theme === "high-contrast"
                                                                ? "high-contrast  "
                                                                : ""
                                                        }`}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600 gap-3">

                                        <button
                                            onClick={handleAddDeparment}
                                            className={`bg-[#236DB4] text-white text-[12px] font-bold p-[10px] rounded-[4px] xsm:max-w-25 w-full`}
                                        >
                                            Save
                                        </button>

                                        <button
                                            onClick={() => setOpen(false)}
                                            className="border border-[#236DB4] text-[#236DB4] text-[12px] font-bold p-[10px] rounded-[4px] xsm:max-w-25 w-full"
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

export default CreateDepartment;